class HoverZoom extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(max-width: 989px)').matches) return; // desktop only

    this.img = this.querySelector('img');
    if (!this.img) return;

    this.highResSrc = this.img.dataset.maxResolution || this.img.currentSrc || this.img.src;

    this.lens = document.createElement('div');
    this.lens.className = 'hover-zoom__lens';

    this.panel = document.createElement('div');
    this.panel.className = 'hover-zoom__panel';
    this.panel.style.backgroundImage = `url(${this.highResSrc})`;

    this.append(this.lens);
    document.body.append(this.panel);

    this.addEventListener('mouseenter', () => this.activate());
    this.addEventListener('mouseleave', () => this.deactivate());
    this.addEventListener('mousemove', (e) => this.move(e));
  }

  activate() {
    this.lens.style.display = 'block';
    this.panel.style.display = 'block';
    this.positionPanel();
  }

  deactivate() {
    this.lens.style.display = 'none';
    this.panel.style.display = 'none';
  }

  positionPanel() {
    const rect = this.getBoundingClientRect();
    this.panel.style.top = `${rect.top + window.scrollY}px`;
    this.panel.style.left = `${rect.right + 16}px`;
    this.panel.style.width = `${rect.width}px`;
    this.panel.style.height = `${rect.height}px`;
  }

  move(e) {
    const rect = this.getBoundingClientRect();
    const lensSize = this.lens.offsetWidth;

    let x = e.clientX - rect.left - lensSize / 2;
    let y = e.clientY - rect.top - lensSize / 2;

    x = Math.max(0, Math.min(x, rect.width - lensSize));
    y = Math.max(0, Math.min(y, rect.height - lensSize));

    this.lens.style.left = `${x}px`;
    this.lens.style.top = `${y}px`;

    const bgX = (x / (rect.width - lensSize)) * 100;
    const bgY = (y / (rect.height - lensSize)) * 100;

    this.panel.style.backgroundPosition = `${bgX}% ${bgY}%`;
    this.panel.style.backgroundSize = '250%'; // zoom level, adjust to taste
  }
}

customElements.define('hover-zoom', HoverZoom);